import moment from 'moment';

export const formatDateAsQuarter = date => moment(date).format('[Q]Q YYYY');
export const formatDateAsAuditTime = date => moment(date).format('MMMM Do YYYY, h:mm a');
